module.exports = __webpack_public_path__ + "static/media/toolsIcon.61556f29.svg";